/**
 * Shared dashboard option keys and labels for frontend dashboard.
 * Used by: Dashboard.js (user-facing) and AdminDashboardOptions.js (admin manage page).
 * Backend stores per main company: array of these keys (order = display order).
 */

export const DASHBOARD_OPTION_KEYS = [
  "seller",
  "buyer",
  "quick",
  "seller2net",
  "refinance",
  "propnine",
  "open",
];

/** Display labels for admin UI */
export const DASHBOARD_OPTION_LABELS = {
  seller: "Seller Net Sheet",
  buyer: "Buyer Calculator",
  quick: "Quick Calculator",
  seller2net: "Seller 2 Net",
  refinance: "Refinance Calculator",
  propnine: "Proposition 19",
  open: "Open Calculator",
};

/** Route/link for each option (shown on dashboard) */
export const DASHBOARD_OPTION_LINKS = {
  seller: "/seller",
  buyer: "/buyer",
  quick: "/quick",
  seller2net: "/seller2net",
  refinance: "/refinance",
  propnine: "/propnine",
  open: "/open",
};

export default DASHBOARD_OPTION_KEYS;
